class CustomShippingDates extends HTMLElement {
  connectedCallback() {
    const textEl = this.querySelector('[data-dynamic-date="true"]');

    if (!textEl) {
      console.warn('❌ CustomShippingDates: nu găsesc elementul de text');
      return;
    }

    console.log('✅ CustomShippingDates INIT');

    const template = textEl.dataset.text || '';
    const dateFormat = this.dataset.dateFormat || 'dd.mm.yyyy';

    const now = new Date();
    const deliveryDate = this.getCustomDeliveryDate(now);
    const formattedDate = this.formatDate(deliveryDate, dateFormat);

    textEl.innerHTML = template
      .replace('[start_date]', formattedDate)
      .replace('[end_date]', formattedDate);

    console.log('✅ Livrare calculată:', {
      azi: now,
      zi: now.getDay(),
      ora: now.getHours(),
      livrare: deliveryDate,
      textFinal: textEl.innerHTML
    });
  }

  getCustomDeliveryDate(date) {
    const day = date.getDay();
    const hour = date.getHours();

    const cutoffDay = Number(this.dataset.cutoffDay || 4);
    const cutoffHour = Number(this.dataset.cutoffHour || 10);

    const delivery = new Date(date);

    if (day === 1) {
      console.log('➡️ LUNI → MARȚI');
      delivery.setDate(date.getDate() + 1);
    } else if (day === 2) {
      console.log('➡️ MARȚI → MIERCURI');
      delivery.setDate(date.getDate() + 1);
    } else if (day === 3) {
      console.log('➡️ MIERCURI → JOI');
      delivery.setDate(date.getDate() + 1);
    } else if (day === cutoffDay && hour < cutoffHour) {
      console.log('➡️ JOI înainte de 10 → VINERI');
      delivery.setDate(date.getDate() + 1);
    } else if (day === cutoffDay && hour >= cutoffHour) {
      console.log('⛔ JOI după 10 → MARȚI');
      delivery.setDate(date.getDate() + 5);
    } else if (day === 5 || day === 6 || day === 0) {
      console.log('📦 VINERI / WEEKEND → MARȚI');
      const daysUntilTuesday = (9 - day) % 7 || 7;
      delivery.setDate(date.getDate() + daysUntilTuesday);
    } else {
      console.log('⚠️ FALLBACK → +1 zi');
      delivery.setDate(date.getDate() + 1);
    }

    return delivery;
  }

  formatDate(date, format) {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();

    return format
      .replace('dd', d)
      .replace('mm', m)
      .replace('yyyy', y);
  }
}

if (!customElements.get('dynamic-dates')) {
  customElements.define('dynamic-dates', CustomShippingDates);
} else {
  console.warn('⚠️ dynamic-dates era deja definit de temă. Scriptul custom nu l-a suprascris.');
}